import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCreditApplication } from 'state/creditApplication';
import useQueryParameters from 'hooks/useQueryParameters';

export interface ApplicationBasedOverrides {
  productChoiceKey: string | undefined;
  selectedCardKey: string | undefined;
  cardChoiceCode: number | undefined;
  optInOut: boolean | null;
}

type ApplicationBasedOverridesHook = () => ApplicationBasedOverrides;

const useApplicationBasedOverrides: ApplicationBasedOverridesHook = () => {
  const {
    productChoiceKey: queryParamsProductChoiceKey,
    cardChoiceCode: queryParamsCardChoiceCode,
    selectedCardKey: queryParamsSelectedCardKey,
    overrideKey: queryParamsOverrideKey,
  } = useQueryParameters();

  const {
    productChoiceKey: creditAppProductChoiceKey,
    cardChoice: creditAppCardChoice,
    selectedCardKey: creditAppSelectedCardKey,
    optInOut,
    overrideKey: creditAppOverrideKey,
  } = useSelector(selectCreditApplication);

  const overrides = useMemo(() => {
    const productChoiceKey = creditAppProductChoiceKey
      ? creditAppProductChoiceKey
      : queryParamsProductChoiceKey;
    const selectedCardKey = creditAppSelectedCardKey
      ? creditAppSelectedCardKey
      : queryParamsSelectedCardKey;
    const cardChoiceCode = creditAppCardChoice
      ? creditAppCardChoice
      : queryParamsCardChoiceCode;

    const overrideKey = creditAppOverrideKey
      ? creditAppOverrideKey
      : queryParamsOverrideKey;

    return {
      productChoiceKey,
      cardChoiceCode,
      selectedCardKey,
      optInOut,
      overrideKey,
    };
  }, [
    creditAppCardChoice,
    creditAppOverrideKey,
    creditAppProductChoiceKey,
    creditAppSelectedCardKey,
    optInOut,
    queryParamsCardChoiceCode,
    queryParamsOverrideKey,
    queryParamsProductChoiceKey,
    queryParamsSelectedCardKey,
  ]);
  return overrides;
};

export default useApplicationBasedOverrides;
